import { combineEpics, Epic } from "redux-observable";
import { retrievePaymentSessionEpic } from "../usecases/retrievePaymentSession/epic";
import { validatePaymentEpic } from "../usecases/validatePayment/epic";

export const paymentRootEpics: Epic =  combineEpics(
    retrievePaymentSessionEpic,
    validatePaymentEpic
)
